import React from "react"
import FieldCRMContact_PopoverMore from "./components/popover-menu/popover-more"
import FieldMultiselectDynamic from "../../../../fields3/generic/multiselect-dynamic/multiselect-dynamic"
import FieldConfig from "../../../../fields3/proto/field-config"
import FieldCRMContacts_Pill from "./components/pill"
import ItemModelV2 from "../../../../model2/item2/item-model"
import TasksViewManager from "../../../../gd-modules/tasks-view/core/manager"
import FieldCrmContacts_TableCell from "./render/table-cell"
import {FieldMultiselect_filterValuesFiller} from "../../../conditions/dropdown"
import FieldProto_updateView from "../../../proto/render/table/function/update-view"

export default class FieldCrmContacts extends FieldMultiselectDynamic {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Crm Contact";

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = _.get(config,'addNoValueOption',true);

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','No contact');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.icon = 'i5-crm-contact';

        this.isSearchable = true;

        this.pillMaxWidth   = 120

        // Here [ConditionType_Includes, ConditionType_Excludes] correctly
        // this.conditionTypes         = [ConditionType_ArrayIntersection]


        this.components.PopoverMenuMore         = this.showMenuMore ? FieldCRMContact_PopoverMore : null
        this.components.Pill                    = FieldCRMContacts_Pill
        this.components.ValueIcon               = <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>


        this.renderComponents.tableCell         = FieldCrmContacts_TableCell

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange

        this.filterValuesFiller                 = FieldMultiselect_filterValuesFiller

    }

    tableCellOnValueChange = async (item: ItemModelV2, value: number | null, manager:TasksViewManager) => {
// console.log("save", this.fieldId, " value=", value)


        // @ts-ignore
        item.task[this.fieldId] = value ? value : null
        // item.task.crmContactIds = value ? value : null

// console.log("udpated = ", item.task.crmContactIds)

        item.task.save()

        item.updateLastUpdateTime() // otherwise it wont re-render

        FieldProto_updateView(manager as TasksViewManager, this)
    }



    getCsvValue(model:any) {
        const options : any = this._getOptions(model[this.fieldId])
        return _.isEmpty(options) ? '' : _.map(options, option=>option.label).join(', ');
    }

    getOptions() {

        if (!this._options) {

            if (gd.session._crmContacts) {
                this._options = gd.session._crmContacts.exportToOptions()
            } else {
                console.error("Try access session.crmContacts but not initialized #jd932")
                return []
            }

        }

        return this._options
    }


    // renderTable(model, onChange, cellWidth) {
    //     switch (this.access(model)) {
    //         case false      : return false;
    //         case 'read'     :
    //         case 'write'    :
    //             return <CrmContactsValueTable field={this} options={this._getOptions(model[this.fieldId])} width={cellWidth} />
    //     }
    // }
}
